import { getCached, fetchTarifs, fetchRealisations } from "@/lib/apiCache";

// Chargement anticipé au survol : le code de la route et ses données arrivent avant le clic.
const MODULES = {
  legal: () => import("@/components/LegalPages"),
  pages: () => import("@/components/NewPages"),
  local: () => import("@/components/LocalPages"),
  visite: () => import("@/components/VisitePage"),
};

const ROUTES = [
  { match: (p) => p === "/annonces", data: () => getCached("annonces", "/annonces") },
  { match: (p) => p.startsWith("/annonces/"), data: null },
  { match: (p) => p === "/nos-realisations", mod: "pages", data: () => fetchRealisations("nos") },
  { match: (p) => p === "/nos-tarifs", mod: "pages", data: fetchTarifs },
  { match: (p) => p.startsWith("/portfolio-photos"), mod: "pages" },
  { match: (p) => p === "/virtualtips", mod: "legal", data: () => getCached("tips", "/tips") },
  { match: (p) => p.startsWith("/blog/"), mod: "legal" },
  { match: (p) => ["/mentions-legales", "/cgu", "/cgv", "/cookies", "/confidentialite", "/politique-de-confidentialite"].includes(p), mod: "legal" },
  { match: (p) => p.startsWith("/visite-virtuelle-") || p.startsWith("/projet-"), mod: "local" },
  { match: (p) => p.startsWith("/visite/"), mod: "visite" },
];

const done = new Set();

export function prefetchRoute(pathname) {
  if (!pathname || done.has(pathname) || pathname === window.location.pathname) return;
  const route = ROUTES.find((r) => r.match(pathname));
  if (!route) return;
  done.add(pathname);
  if (route.mod) MODULES[route.mod]().catch(() => {});
  if (route.data) route.data().catch(() => {});
}
